import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { OperatorStatus } from '../models';

@Injectable()
export abstract class OperatorStatusesService {
    abstract createOperatorStatus(backgroundColor: string, color: string, name: string): Promise<OperatorStatus>;

    abstract updateOperatorStatus(operatorStatusId: string, data: { 
        backgroundColor: string;
        color: string;
        name: string; 
    }): Promise<void>;

    abstract operatorStatuses(): Observable<OperatorStatus[]>;

    abstract operatorStatusColors(labels: string[], operatorStatuses: OperatorStatus[]): string[];

    abstract operatorStatus(id: string): Promise<OperatorStatus>;
}
